import { createContext } from 'react';

import type { PortalSessionValue } from './portalSessionTypes';

export const PortalSessionContext =
  createContext<PortalSessionValue | null>(null);
